const GET_MOVIES = "GET_MOVIES";
const GET_MOVIES_WITH_ID = "GET_MOVIES_WITH_ID";
const SEARCH_MOVIE = "SEARCH_MOVIE";
const ADD_MOVIE = "ADD_MOVIE";
const DELETE_MOVIE = "DELETE_MOVIE";
const UPDATE_MOVIE = "UPDATE_MOVIE";
const UPDATE_MOVIE_IN_DATABASE = "UPDATE_MOVIE_IN_DATABASE";
const ADD_WANTED_MOVIE = "ADD_MOVIE";
const REMOVE_WANTED_MOVIE = "REMOVE_MOVIE";
const SEEN_MOVIE = "SEEN_MOVIE";
const UNSEEN_MOVIE = "UNSEEN_MOVIE";

export {
  GET_MOVIES,
  GET_MOVIES_WITH_ID,
  DELETE_MOVIE,
  SEARCH_MOVIE,
  ADD_MOVIE,
  UPDATE_MOVIE,
  UPDATE_MOVIE_IN_DATABASE,
  ADD_WANTED_MOVIE,
  REMOVE_WANTED_MOVIE,
  SEEN_MOVIE,
  UNSEEN_MOVIE,
};
